const Menu = [
    { header: 'Nadzorna Plošča' },
    {
        name: 'pregled',
        title: 'Pregled',
        icon: 'dashboard',
        group: 'nadzorna_plosca'
    },
    {
        name: 'users-list',
        title: 'Seznam uporabnikov',
        icon: 'list_alt',
        group: 'nadzorna_plosca'
    },
    {
        name: 'add-user',
        title: 'Dodaj uporabnika',
        icon: 'group_add',
        group: 'nadzorna_plosca',
        component: ''
    }
]

export default Menu